import { UserAvatar } from 'Components/shared/UserAvatar';
import { cn } from '~/lib/utils';
import React from 'react';
import { CallLogInfoProps } from './types';

/**
 * Renders the contact identity section of a call log row (avatar, name and phone number, if provided)
 * Used alongside CallLogDuration and CallLogRowButtons inside CallLogListItem
 */
export const CallLogInfo: React.FC<CallLogInfoProps> = ({
  nameToDisplay,
  avatarToDisplay,
  phoneNumberToDisplay,
  isPersonInactive,
  isUnsavedContact,
  presence,
  category,
  icon,
}) => (
  <div className="flex flex-row items-center">
    <UserAvatar
      name={isUnsavedContact ? '' : nameToDisplay}
      hideInitials={!nameToDisplay}
      presence={presence}
      isInactive={isPersonInactive}
      image={avatarToDisplay}
    />
    <div className="ml-[16px]">
      <div className="text-[#333e48] font-bold text-[16px] leading-[26px]" data-testid="call-log-title">
        {`${nameToDisplay}${isPersonInactive ? ' [Inactive]' : ''}` || 'Unknown'}
      </div>
      <div
        className={cn('flex items-center text-[13px] leading-[21px] text-[#546877] gap-[10px]', {
          'text-destructive': category === 'missed',
        })}
        data-testid="call-log-subtitle"
      >
        <div className="inline-flex gap-[10px]">
          <img src={icon} />
          <div className="capitalize">{category}</div>
        </div>
        {phoneNumberToDisplay && (
          <>
            <span className={cn('w-[3px] h-[3px] bg-[#546877] rounded-full', {
              'bg-destructive': category === 'missed',
            })} />
            {phoneNumberToDisplay}
          </>
        )}
      </div>
    </div>
  </div>
);